import classNames from "classnames";
import Group from "./Group";
import styles from "./GroupSelectCell.module.css";
import { useTranslation } from "react-i18next";
import { convertGroupString } from "./groups";
import MoreButton from "../common/MoreButton";
import SpacingView from "../common/view/SpaingView";
import Collection from "../collection/model/Collection";

interface GroupSelectCellProps {
  group: Group;
  collections: Collection[];

  handleOnClickCell: (group: Group) => void;
  handleOnClickMoreButton: (
    e: React.MouseEvent<HTMLDivElement>,
    group: Group
  ) => void;
}

export default function GroupSelectCell(props: GroupSelectCellProps) {
  const { t } = useTranslation();

  const containerClass = classNames(styles.container, {
    [styles.selectedContainer]: props.group.selected === true,
    [styles.readyContainer]: props.group.selected === false,
  });

  const collectionNameClass = classNames(styles.collectionNameText, {
    [styles.selectedCollectionName]: props.group.selected,
  });

  const groupnameClass = classNames(styles.groupnameText, {
    [styles.selectedGroupnameText]: props.group.selected === true,
    [styles.readyGroupnameText]: props.group.selected === false,
  });

  const termCountClass = classNames(styles.termCountText, {
    [styles.selectedTermCountText]: props.group.selected === true,
    [styles.readyTermCountText]: props.group.selected === false,
  });

  const percentageClass = classNames(styles.learningPercentangeText, {
    [styles.selectedPercentageText]: props.group.selected === true,
    [styles.readyPercentageText]: props.group.selected === false,
  });

  function handleOnClickMoreButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    if (!props.group.isAllGroup && !props.group.isUnspecifiedGroup) {
      props.handleOnClickMoreButton(e, props.group);
    }
  }

  function getGroupCollection(): Collection | undefined {
    return props.collections
      .filter((collection) => !collection.isDefaultCollection)
      .find((collection) => collection.id === props.group.collectionId);
  }

  return (
    <>
      <div
        className={containerClass}
        onClick={() => props.handleOnClickCell(props.group)}
      >
        <div className={styles.contentContainer}>
          <div className={styles.leftContainer}>
            <span className={collectionNameClass}>
              {getGroupCollection()?.title ?? null}
            </span>
            <SpacingView height={4} />
            <p className={groupnameClass}>{convertGroupString(props.group)}</p>
            <SpacingView height={12} />
            <p className={termCountClass}>
              {t("GroupSelectTermCount", { termCount: props.group.termCount })}
            </p>
          </div>
          <div className={styles.rightContainer}>
            {!props.group.isAllGroup && !props.group.isUnspecifiedGroup && (
              <MoreButton
                color={
                  props.group.selected
                    ? "var(--text-primary-inverted-color)"
                    : undefined
                }
                onClick={handleOnClickMoreButton}
              />
            )}
            {(props.group.isAllGroup || props.group.isUnspecifiedGroup) && (
              <SpacingView height={4} />
            )}
            <span className={percentageClass}>
              {t("GroupLearningPercentage", {
                percentage: props.group.learningPercentange,
              })}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
